<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <h3>Núcleo de produção</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col :cols="dynamicCol">
            <v-autocomplete
                v-model="IdUnidadeFiltro"
                :items="unidadesList"
                item-text="Unidade"
                item-value="IdUnidade"
                label="Unidade"                
                hide-details
                outlined
                dense
                clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-select
                :items="listSebraetec"
                v-model="SebraetecFiltro"
                item-text="status"
                item-value="id"
                label="Sebraetec"                
                hide-details
                outlined
                dense
                clearable
            ></v-select>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-select
                v-model="statusAgendamento"
                :items="listStatusAgendamento"
                item-text="name"
                item-value="id"
                label="Situação"                
                hide-details
                outlined
                dense
            ></v-select>
          </v-col>          
          <v-col :cols="dynamicCol">            
            <v-btn
              @click="getContratos"
              color="primary"
              class="mt-3"
              dark
              block
              >Buscar</v-btn
            >            
          </v-col>
        </v-row>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" xl="12">
            <v-text-field
              v-model="search"
              prepend-icon="mdi-feature-search-outline"
              label="Pesquisar"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
        <v-data-table
            :headers="headersContratos"
            :items="contratos"
            :search="search"
            class="elevation-1"
            :loading="myloadingvariable"
            :expanded.sync="expanded"
            item-key="IdContrato"
            show-expand
            single-expand
            loading-text="Carregando..."
        >
          <template v-slot:[`item.Sebraetec`]="{ item }">
            <v-chip v-if="item.Sebraetec" class="blue" dark>Sim</v-chip>
            <v-chip v-else class="gray" dark>Não</v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="pathDocumento(item)" icon>
                  <v-icon>mdi-file-document</v-icon>
                </v-btn>
              </template>
              <span>ver contrato</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"  @click="[getTermoDetalhes(item), modalTermoDetalhes = true]" icon>
                  <v-icon>mdi-information</v-icon>
                </v-btn>
              </template>
              <span>informações do contrato</span>
            </v-tooltip>            
            <v-tooltip v-if="item.agendamentos[0].IdStatusProcesso == 4" bottom>
              <template v-slot:activator="{ on, attrs }">                  
                  <v-btn v-bind="attrs" v-on="on" color=primary icon @click="[modalJustificativa = !modalJustificativa, setItemData(item)]">
                    <v-icon>mdi-skip-forward</v-icon>
                  </v-btn>
                </template>
              <span>enviar para faturamento</span>
            </v-tooltip>
            <v-tooltip v-else bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color=red @click="[modalJustificativaResgate = !modalJustificativaResgate, setItemData(item)]">
                  <v-icon>mdi-skip-backward</v-icon>
                </v-btn>
              </template>
              <span>resgatar do faturamento</span>
            </v-tooltip>
          </template>

          <template v-slot:expanded-item="{ item }">
            <td colspan="12" style="padding: 10px">
              <v-data-table
                :headers="headersAgendamentos"
                :items="item.agendamentos"
                :loading="loading"
                loading-text="Carregando..."
                class="elevation-0"
                hide-default-footer
                disable-pagination
                :expanded.sync="expandedServicos"
                item-key="IdAgendamento"
                show-expand
                single-expand
              >
                  <template v-slot:[`item.dataInicial`]=" { item } ">
                    {{ $moment(item.dataInicial).format('L') }}
                  </template>
                  <template v-slot:[`item.cobrarTaxaDeslocamento`]="{ item }">
                      <v-chip v-if="item.cobrarTaxaDeslocamento == 0" @click="changeTaxaDeslocamento(item.IdAgendamento, 1)" class="red" dark> Não </v-chip>
                      <v-chip v-else class="green" @click="changeTaxaDeslocamento(item.IdAgendamento, 0)" dark> Sim </v-chip>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <!-- <v-tooltip v-if="item.estatistica" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon>
                          <v-icon color="green">mdi-chart-areaspline</v-icon>
                        </v-btn>
                      </template>
                      <span>liberado para a estatística</span>
                    </v-tooltip>
                    <v-tooltip v-else bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-if="item.contarEstatistica == 2" v-on="on" icon @click="[enviarParaEstatistica(item.IdAgendamento)]">
                          <v-icon>mdi-chart-areaspline</v-icon>
                        </v-btn>
                        <v-btn v-else-if="item.contarEstatistica == 1" v-bind="attrs" v-on="on" icon>
                          <v-icon color="green">mdi-chart-areaspline</v-icon>
                        </v-btn>
                        <v-btn v-else v-bind="attrs" v-on="on" disabled icon>
                          <v-icon color="green">mdi-chart-areaspline</v-icon>
                        </v-btn>
                      </template>
                      <span v-if="item.contarEstatistica == 2">liberar para a estatística</span>
                      <span v-else-if="item.contarEstatistica == 1">liberado automaticamente para a estatística</span>
                    </v-tooltip> -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on"
                          icon @click="[getServicosAnexos(item.IdAgendamento)]">
                        <v-icon>mdi-file-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>visualizar anexos</span>
                    </v-tooltip>
                  </template>

                  <template v-slot:expanded-item="{ item }">
                    <td colspan="12" style="padding: 10px">
                      <v-data-table
                        :headers="headersServicos"
                        :items="item.procedimentos"
                        :loading="loading"
                        loading-text="Carregando..."
                        class="elevation-0"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:[`item.quantidadeExecutada`]="{ item }">
                          <v-chip v-if="item.quantidadeExecutada > item.quantidadePessoas" class="blue" dark> {{ item.quantidadeExecutada }} </v-chip>
                          <v-chip v-else-if="item.quantidadeExecutada < item.quantidadePessoas" class="red" dark> {{ item.quantidadeExecutada }} </v-chip>
                          <v-chip v-else class="green" dark> {{ item.quantidadeExecutada }} </v-chip>
                        </template>

                        <template v-slot:[`item.preco.ValorUnitario`]=" { item } ">
                          {{ item.preco.ValorUnitario | numeral('$ 0,0.00') }}
                        </template>

                        <template v-slot:[`item.valorTotal`]=" { item } ">
                          {{ item.preco.ValorUnitario * item.quantidadeExecutada | numeral('$ 0,0.00') }}
                        </template>

                      </v-data-table>
                    </td>
                  </template>

              </v-data-table>
            </td>
          </template>
          
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog width="80%" scrollable v-model="modalTermoDetalhes">
        <v-card>
            <v-card-title>
                Informações do contrato
                <v-spacer></v-spacer>
                <v-btn @click="[modalTermoDetalhes = !modalTermoDetalhes, termoDetalhes = []]" icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-list-item-title>
                CNPJ: {{modalInfo.CNPJ}}
              </v-list-item-title>
              <v-list-item-title>
                Razão Social: {{modalInfo.RazaoSocial}}
              </v-list-item-title>
              <v-list-item-title>
                Número do contrato: {{modalInfo.NumeroContrato}}
              </v-list-item-title>
              <v-list-item-title>
                Período de vigência: {{`${$moment(modalInfo.VigenciaInicio).format('L')}`}} à {{`${$moment(modalInfo.VigenciaFim).format('L')}`}}
              </v-list-item-title>
                <v-data-table
                :items="termoDetalhes"
                :headers="headersDetalhes"
                :search="searchDetalhes"
                >
                <template v-slot:[`item.ValorUnitario`]=" { item } ">
                  {{ item.ValorUnitario | numeral('$ 0,0.00') }}
                </template>
                <template v-slot:[`item.Percentual`]=" { item } ">
                  <k-progress
                      status="success"
                      type="line"
                      :percent="item.Progresso > 100 ? parseInt(item.Progresso = 100) : parseInt(item.Progresso)">
                    line-height="20px"
                  </k-progress>
                </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog width="80%" scrollable v-model="modalJustificativa">
        <v-card>
            <v-card-title>
                Enviar contrato para faturamento - Contrato {{ this.numContrato }}
                <v-spacer></v-spacer>
                <v-btn @click="[modalJustificativa = !modalJustificativa, nullFields()]" icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>

            <v-text-field 
              class="ma-5" 
              v-model="parcelas"
              min="1"
              max="10" 
              label="Quantidade de parcelas desejadas?" 
              persistent-hint
              outline type="number" 
              :rules="[rules.required]"
            ></v-text-field>
            
            <v-select
              class="ma-5"
              v-model="finalizar"
              :items="finalizarOpcoes"
              item-text="name"
              item-value="id"              
              label="Finalizar contrato após o faturamento?"              
            ></v-select>

            <v-text-field
              label="Orientações"
              :rules="[rules.required]"
              v-model="justificativaText"
              class="ma-5"
            ></v-text-field>
            
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  :loading="this.loadButtonFaturamento"
                  :disabled='!justificativaText || finalizar == null || !parcelas'
                  color="primary"
                  @click="[loader = 'loading', sendFaturamento()]"
              >
                Enviar para faturamento
              </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog width="80%" scrollable v-model="modalJustificativaResgate">
        <v-card>
            <v-card-title>
                Resgatar contrato do faturamento - Contrato {{ this.numContrato }}
                <v-spacer></v-spacer>
                <v-btn @click="[modalJustificativaResgate = !modalJustificativaResgate, nullFields()]" icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-text-field
              clearable
              :rules="[rules.required]"
              label="Observação"
              v-model="justificativaText"
              class="ma-5"
            ></v-text-field>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  :loading="this.loadButtonFaturamento"
                  :disabled='!justificativaText'
                  color="primary"
                  @click="[loader = 'loading', resgateFaturamento()]"
              >
                Resgatar do faturamento
              </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <AlertSystem :snackbar="system.snackbar"></AlertSystem>

    <!-- Gerenciar participantes do agendamento -->

    <v-dialog width="60%" scrollable v-model="dialogServicosAnexos" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card flat>
        <v-card-title>
          Gerenciar anexos do agendamento
          <v-spacer></v-spacer>
          <v-btn icon @click="[dialogServicosAnexos = false, fecharModal()]">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-10 pt-2 pb-4" v-if="servicos[0] !=null" >
          <v-row>
            <template>
              <strong>CNPJ: {{servicos[0].CNPJ}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Razão social: {{servicos[0].RazaoSocial}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Título: {{servicos[0].titulo}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Data: {{`${$moment(servicos[0].DataInicial).format('L')}`}} </strong>
            </template>
          </v-row>
        </v-card-text>
        <v-card-text class="mb-0 pb-0">
          <v-tabs :grow="true" v-model="tab" v-if="servicos!=null">
            <template v-for="servico in servicos">
              <v-tab v-if="servico.IdProcedimento != 818 && servico.ServicoCertificado" :key="servico.index" @click="getAnexos(servico.IdAgendamentoServico)">{{servico.Procedimento}} ({{servico.quantidadeCertificada}}/{{servico.quantidadeExecutada}}) </v-tab>
            </template>
          </v-tabs>
          <div v-if="qtdAnexos > 0" class="pl-0 pt-2 pb-0 mb-0">
            <template v-for="ocorrencia in ocorrencias" class="mb-0">
              <v-alert
                  :key="ocorrencia.index"
                  color="primary"
                  dark
                  dense
              >
                <v-row align="center">
                  <v-col xl="9" lg="9" md="8" sm="6" xs="12">
                    {{ ocorrencia.originalName }} : {{`${$moment(ocorrencia.created_at).format('L')}`}}
                  </v-col>
                  <v-col xl="3" lg="3" md="4" sm="6" xs="12">
                    <v-btn
                        color="white primary--text"
                        @click="acessarEvidencia(ocorrencia.IdAgendamentoServico, `${$moment(ocorrencia.created_at).format('YYYY-MM-DD HH:mm:ss')}`)"
                    >
                      Download
                      <v-icon
                          right
                          dark
                      >
                        mdi-download
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>
            </template>
          </div>
        </v-card-text>
        <v-card-text class="pa-0 ma-0">
          <v-alert
              v-if="qtdAnexos === 0"
              color="primary"
              class="ml-6 mr-6"
              dark
              icon="mdi-alert"
              prominent
          >
            Não há anexos para esse serviço ainda
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import AlertSystem from "../components/AlertSystem.vue";
// import moment from "moment";
export default {
  name: "Nucleo",
  components: {
    AlertSystem,    
  },
  data: () => ({
    system: {
      snackbar: {},
    },
    headersContratos: [
      { text: "", value: "data-table-expand" },
      { text: "CNPJ", value: "empresa.CNPJ" },
      { text: "Razão Social", value: "empresa.RazaoSocial" },
      { text: "Unidade", value: "unidade.Sigla" },
      { text: 'Contrato', value: 'NumeroContrato'},
      { text: "Sebraetec", value: "Sebraetec" },
      { text: "Ações", value: "actions", align: 'right' }
    ],    
    headersAgendamentos: [      
      { text: "ID", value: "IdAgendamento" },
      { text: "Data", value: "dataInicial" },
      { text: "Titulo", value: "titulo" },
      { text: 'Taxa de deslocamento', value: 'cobrarTaxaDeslocamento' },
      { text: 'Observação', value: 'obs_interna'},      
      { text: "Anexos", value: "actions", align: 'right' }
    ],
    headersServicos: [
      { text: "Nome do credenciado", value: "credenciado.Nome" },
      { text: "Serviço realizado", value: "procedimento.Procedimento" },
      { text: "Agendado", value: "quantidadePessoas", align: "right" },
      { text: "Realizado", value: "quantidadeExecutada", align: "right" },
      { text: "Valor unitário", value: "preco.ValorUnitario", align: "right" },
      { text: "Valor do serviço", value: "valorTotal", align: "right" }
    ],
    headersExecucoes: [
      { text: "Nome", value: "Nome" },
      { text: "CPF", value: "CPF" },
      { text: "Quantidade", value: "quantidade", align: "center" }
    ],
    headersDetalhes: [
      {text: "Procedimento", value: "ServicoContratado"},
      {text: "Valor Unitário", value: "ValorUnitario"},
      {text: "Qtd. Contratada", value: "QuantidadeContratada"},
      {text: "Qtd. Consumida", value: "QuantidadeConsumida"},
      {text: "Percentual realizado", value: "Percentual"}
    ],
    contratos: [],
    expanded: [],
    rules: {
      required: value => !!value || 'Campo obrigatório',
    },
    loadButtonFaturamento: false,
    modalJustificativa: false,
    modalJustificativaResgate: false,
    justificativaText: null,
    parcelas: null,
    finalizar: null,
    numContrato: null,
    IdContrato: null,        
    searchDetalhes: '',
    IdEmpresa: '',
    IdAgendamentoServico: '',
    IdAgendamento: '',
    addParticipantesView: false,
    statusAgendamento: 4,
    unidadesList: [],    
    finalizarOpcoes: [
      {
        id: 0,
        name: 'Não'
      },
      {
        id: 1,
        name: 'Sim'
      }
    ],
    listStatusAgendamento:[
      {
        id: 4,
        name: 'Contratos no núcleo de produção'
      },
      {
        id: 5,
        name: 'Contratos enviados para faturamento'
      }
    ],
    listSebraetec:[
      {
        id: 1,
        status: 'Sim'
      },
      {
        id: 2,
        status: 'Não'
      }
    ],
    IdUnidadeFiltro: null,
    dynamicCol: 2.4,
    search: "",
    searchExecucoes: "",
    searchFuncionarios: "",
    searchFuncionariosAdd: "",
    arrayFinal:[],
    empresas: [],
    ocorrencias: [],
    qtdAnexos: 0,
    servicos: {},
    existemExecucoes: false,
    execucoes: [],
    funcionarios: [],    
    myloadingvariable: false,
    tab: null,
    // Anexos
    files: null,
    dialogServicosAnexos: false,
    modalTermoDetalhes: false,
    loadTermos: null,
    termoDetalhes: [],
    modalInfo: [],
    SebraetecFiltro: 2,
    termos: []
  }),
  methods: {
    pathDocumento (item) {
      let arrAux = this.termos.filter(arr => {
        if(arr.NumeroContrato === item.NumeroContrato && arr.CNPJ === item.empresa.CNPJ){
          return arr
        }
      })
      if(arrAux != null){
        arrAux.filter(arr => {
          window.open(`https://sis.rn.sesi.org.br/gs/${arr.Path.substring(2, arr.Path.length)}`, )
        })
      }
    },
    setItemData(item) {
      this.IdContrato = item.IdContrato
      this.numContrato = item.NumeroContrato
    },
    nullFields(){
      this.IdContrato = null
      this.numContrato = null
      this.justificativaText = null
      this.parcelas = null
      this.finalizar = null
    },
    getUnidades () {
      this.axios('unidades').then(res => {
        this.unidadesList = res.data
      })
    },
    getAnexos(idAgendamento){
      this.axios.get(`execucoes/evidencias/${idAgendamento}`)
          .then(res => {
                this.ocorrencias = res.data
                this.qtdAnexos = res.data.length
              }
          )
    },
    getTermoDetalhes (item) {      
      this.loadTermos = true
      this.axios.get(`/termos/${item.IdContrato}/empresas/${item.IdEmpresa}`).then( res => {
        this.termoDetalhes = res.data.filter(arr => {
          if(arr.QuantidadeContratada != 0){
            arr.Progresso = parseFloat(((arr.QuantidadeConsumida / arr.QuantidadeContratada) * 100)).toFixed(0)
            return arr
          }
          else{
            arr.Progresso = 0
            return arr
          }
        })
        this.modalInfo = item
      }).finally(() => {
        this.loadTermos = false
      })
    },
    acessarEvidencia(idAgendamento, DataOcorrencia){
      this.axios.get(`agendamentos/${idAgendamento}/evidencias/${DataOcorrencia}`,{
        responseType: 'arraybuffer'
      }).then((res) => {
        this.forceFileDownload(res, DataOcorrencia + '.pdf')
      })
    },
    forceFileDownload(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },    
    getContratos () {
      this.nullFields()
      this.myloadingvariable = true;
      this.axios.get("termos", {
        params:{
          IdUnidade: this.IdUnidadeFiltro,
          Sebraetec: this.SebraetecFiltro,
          statusAgendamento: this.statusAgendamento          
        }
      }).then(res => {
        this.contratos = res.data
      }).catch(e => {
        alert(e);
      }).finally(() => {
        this.myloadingvariable = false;
      });
    },
    getIdEmpresa (IdEmpresa){
      this.IdEmpresa = IdEmpresa
    },
    getServicos(IdAgendamento) {
      this.myloadingvariable = true;
      this.axios
        .get(`agendamentos/${IdAgendamento}/servicos`)
        .then(res => {
          this.servicos = res.data;

          this.tab = 0
          // Se for ASO.
          if(res.data[0].IdServico == 818){
            for(let j=0; j < res.data.length; j++){
              if(res.data[j].IdServico != 818 && res.data[j].IdAgendamentoServico){
                var IdAgendServ = res.data[j].IdAgendamentoServico
                break
              }
            }
            this.getExecucoes(IdAgendServ, res.data[1].IdAgendamento);
          }else{
            this.getExecucoes(res.data[0].IdAgendamentoServico, res.data[0].IdAgendamento);
          }

          this.IdAgendamentoServico = res.data[0].IdAgendamentoServico
          for(var i=0;i<res.data.length;i++){
            if(this.servicos[i].quantidadeExecutada==null){
              this.servicos[i].quantidadeExecutada = 0;
            }
          }
        })
        .catch(() => {
        })
        .finally(() => {
          this.myloadingvariable = false;
        });
    },
     getServicosAnexos(IdAgendamento) {
      this.myloadingvariable = true;
      this.axios.get(`agendamentos/${IdAgendamento}/servicos`).then(res => {
        this.servicos = res.data
        this.IdAgendamentoServico = res.data[0].IdAgendamentoServico

        res.data[0].IdServico != 818
          ? this.IdAgendamentoServico = res.data[0].IdAgendamentoServico
          : this.IdAgendamentoServico = res.data.filter(arr => { return arr.IdServico != 818 && arr.IdAgendamentoServico })

        this.getAnexos(this.IdAgendamentoServico)
      }).finally(() => {
        this.myloadingvariable = false;
        if (!this.dialogServicosAnexos) this.dialogServicosAnexos = true
      });
    },
    deletarAnexo(servicoIndex, id) {
      this.servicos[servicoIndex].anexos = this.servicos[servicoIndex].anexos.filter(anexo => anexo.id !== id)
      this.axios.delete(`servicos/anexos/${id}`)
          .then(() => {
            this.getServicos(this.IdAgendamento)
          })
    },
    getExecucoes(IdAgendamentoServico, IdAgendamento) {
      this.IdAgendamento = IdAgendamento
      this.myloadingvariable = true;
      this.execucoes = []
      this.axios
          .get(`agendamentos/${IdAgendamento}/servicos/${IdAgendamentoServico}/execucoes`)
          .then(res => {
            this.execucoes = res.data
          })
          .catch(() => {
            this.existemExecucoes = false;
          })
          .finally(() => {
          });
    },
    enviarParaEstatistica(IdAgendamento){
      var ok = confirm('Gostaria de liberar esse agendamento para a estatística?')
      if(ok){
        this.axios.patch(`agendamentos/${IdAgendamento}`).then( res => {
          this.system.snackbar = {
            snackbar: true,
            text: res.data,
            color: "green",
          }
        }).catch((e) => {
          this.system.snackbar = {
            snackbar: true,
            text: e.response.data,
            color: "red",
          }
        })
        this.getContratos()        
      }
    },
    changeTaxaDeslocamento(IdAgendamento, changeCobranca){
      var ok = confirm('Deseja modificar a cobrança da taxa de deslocamento?')
      if(ok){
        this.axios.put(`agendamentos/${IdAgendamento}/taxa`,{
          cobrarTaxaDeslocamento: changeCobranca
        }).then( res => {
          this.system.snackbar = {
            snackbar: true,
            text: res.data,
            color: "green",
          }
        }).catch((e) => {
          this.system.snackbar = {
            snackbar: true,
            text: e.response.data,
            color: "red",
          }
        })
        this.getContratos()        
      }
    },
    sendFaturamento(){
      this.loadButtonFaturamento = true;
      this.axios.put(`contratos/${this.IdContrato}/enviarfaturamento`, {
        justificativa: this.justificativaText,
        parcelas: this.parcelas,
        finalizar: this.finalizar,
      }).then(() => {        
        this.modalJustificativa = !this.modalJustificativa,
        this.system.snackbar = {
          snackbar: true,
          text: "Contrato enviado para faturamento",
          color: "green",
        };
        this.nullFields()
        this.getContratos()
      }).catch((e) => {
          this.system.snackbar = {
            snackbar: true,
            text: e.response.data,
            color: "red",
          }
      }).finally(() => {
        this.loadButtonFaturamento = false;        
      })
    },
    resgateFaturamento(){
      this.loadButtonFaturamento = true;
      this.axios.put(`contratos/${this.IdContrato}/resgatarfaturamento`, {
        justificativa: this.justificativaText
      }).then(() => {
        this.modalJustificativaResgate = !this.modalJustificativaResgate,        
        this.system.snackbar = {
          snackbar: true,
          text: "Contrato resgatado do faturamento",
          color: "green",
        };
        this.getContratos()
      }).catch((e) => {
          this.system.snackbar = {
            snackbar: true,
            text: e.response.data,
            color: "red",
          }
      }).finally(() => {
        this.loadButtonFaturamento = false;        
      })
    },    
  },
  mounted() {
    this.getUnidades()
    //this.getContratos()
  }
};
</script>

<style scoped>
</style>
